/* Copyright (c) 2020-2022, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Logger, LoggingService } from './logging.service';
import { LogEvent, LogLevel } from './models/logger-info-models';

@Injectable({
    providedIn: 'root'
})
export class LibraryLoggingService {
    private logger: Logger;

    constructor(private loggingService: LoggingService) {}

    private logBasedOnLevel(data: LogEvent) {
        switch (data.logLevel) {
            case LogLevel.INFO:
                this.logger.info(data.logStr, data.timeStamp);
                break;
            case LogLevel.DEBUG:
                // Treat debug log as info log as GFNClient uses INFO as default logging level.
                // If we try to print debug logs in such a case, they will get discarded due to
                // current implementation of logEntry() in loggingService.
                this.logger.info(data.logStr, data.timeStamp);
                break;
            case LogLevel.ERROR:
                this.logger.error(data.logStr, data.timeStamp);
                break;
            case LogLevel.WARN:
                this.logger.warn(data.logStr, data.timeStamp);
                break;
        }
    }

    sendLog(data: LogEvent) {
        this.logger = this.loggingService.getLogger(data.logModule ? data.logModule + '/' + data.logTag : data.logTag);
        this.logBasedOnLevel(data);
    }
}
